// extracted by mini-css-extract-plugin
export default {"Container":"GroupedAvatars_Container__qZtNj","Checked":"GroupedAvatars_Checked__ZtKYB","More":"GroupedAvatars_More__GOMeB"};